import {
  type DashboardClassroomDiagnosticTriggerEntity,
  type DashboardClassroomDiagnosticTriggerInputEntity,
  DashboardClassroomDiagnosticTriggerInputSchema,
  DashboardClassroomDiagnosticTriggerSchema
} from '@/core/infrastructure/schemas/dashboard/DashboardClassroomDiagnosticTriggerSchema.ts'
import { QuizType } from '@/core/domain/resources/enums/QuizType.ts'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'

export class DashboardClassroomDiagnosticTrigger {
  readonly id: number
  readonly schoolClassroomId: number
  readonly quizId: number
  readonly quizType: QuizType.Values
  readonly triggerTime: Date
  readonly createdByUser: string

  constructor(classroomDiagnosticTrigger: DashboardClassroomDiagnosticTriggerEntity) {
    this.id = classroomDiagnosticTrigger.id
    this.schoolClassroomId = classroomDiagnosticTrigger.schoolClassroomId
    this.quizId = classroomDiagnosticTrigger.quizId
    this.quizType = classroomDiagnosticTrigger.quizType
    this.triggerTime = new Date(classroomDiagnosticTrigger.triggerTime)
    this.createdByUser = classroomDiagnosticTrigger.createdByUser
  }

  public static create(data: unknown): DashboardClassroomDiagnosticTrigger {
    return EntityValidator.validateAndCreate(
      DashboardClassroomDiagnosticTriggerSchema,
      data,
      DashboardClassroomDiagnosticTrigger,
      'DashboardClassroomDiagnosticTrigger'
    )
  }
}

export class DashboardClassroomDiagnosticTriggerInput {
  readonly id: number
  readonly schoolClassroomId: number
  readonly learningCourseName: string
  readonly quizType: QuizType.Values
  readonly triggerTime: Date

  constructor(
    classroomDiagnosticTriggerInputEntity: DashboardClassroomDiagnosticTriggerInputEntity
  ) {
    this.id = classroomDiagnosticTriggerInputEntity.id
    this.schoolClassroomId = classroomDiagnosticTriggerInputEntity.schoolClassroomId
    this.learningCourseName = classroomDiagnosticTriggerInputEntity.learningCourseName
    this.quizType = classroomDiagnosticTriggerInputEntity.quizType
    this.triggerTime = new Date(classroomDiagnosticTriggerInputEntity.triggerTime)
  }

  public static create(data: unknown): DashboardClassroomDiagnosticTriggerInput {
    console.log(data)
    return EntityValidator.validateAndCreate(
      DashboardClassroomDiagnosticTriggerInputSchema,
      data,
      DashboardClassroomDiagnosticTriggerInput,
      'DashboardClassroomDiagnosticTrigger'
    )
  }
}
